const LOCAL_BACKEND_URL = () => process.env.REACT_APP_LOCAL_BACKEND_URL;

export default LOCAL_BACKEND_URL;
